import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LoginButtons from './LoginButtons';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ArtistService from '../../services/artistService';
import * as accountActions from '../../actions/accountActions';
import UserOptions from './UserOptions';

class SideMenu extends Component {
    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        $('#sidemenu .hassub>a').on('click', this.toggleMenu);

        $('body').on('click', this.closeSideNav);       
    }    

    componentDidUpdate(prevProps) {
        if(prevProps.user !== this.props.user) {
            $('#sidemenu .hassub>a').off('click', this.toggleMenu);
            $('#sidemenu .hassub>a').on('click', this.toggleMenu);
        }
    }

    componentWillUnmount() {
        $('body').off('click', this.closeSideNav);
    }

    closeSideNav(e) {
        const target = $(e.target);
        const hasSubmenu = target.parent().hasClass('hassub');
        //&& (target.hasClass('btn-closesidemenu') || target.parents('.sidemenu').length === 0 || target.hasClass('btn-login') || target.hasClass('btn-signup'))
        //as long as we aren't opening a submenu, close
        if($('body').hasClass('showside') && !hasSubmenu) {
            //e.preventDefault();
            $('body').removeClass('showside');
        }
    }
    
    toggleMenu(e) {
        e.preventDefault();
        const clickedItem = $(this);
        const menu = clickedItem.parent('li.hassub');
        const submenu = menu.find('ul.sub');      
        submenu.slideToggle();
        clickedItem.toggleClass('open');
    }

    render() {
        const props = this.props;
        return (
            <section id="sidemenu" className="sidemenu">
            <a href="#" className="btn-closesidemenu" onClick={this.closeSideNav}>&times;</a>
            {
                !this.props.user ?
                    <div className="user">                
                        <LoginButtons sideMenu /> 
                    </div> 
                    : 
                    null               
            }    
            <div className="menu">
                <nav>
                    <ul className="list-unstyled list-mmenu">
                        {
                            this.props.user ?
                                <li className="hassub" id="userOptions">
                                    <a href="#" className="navbar-user">
                                        <span className="avatar">
                                            <svg className="icon icn-user transition">
                                                <use xlinkHref="#icn-user" />
                                            </svg>
                                        </span>
                                        {this.props.user.activeProfile ? <span className="username">ME </span> : <span className="username" style={{fontSize: '12px', maxWidth: '120px'}}>No profiles created yet </span>}
                                        <span className="caret" />
                                    </a>
                                    <ul className="sub">
                                        <UserOptions actions={this.props.actions} user={this.props.user} sideMenu />
                                    </ul>
                                </li>
                            : null
                        }

                        <li><Link to="/HowItWorks">HOW IT WORKS</Link></li>
                        <li className="hassub">
                            <a href="#">EXPLORE <span className="caret" /></a>
                            <ul className="sub">
                                <li><Link to="/Fans" className="transition">Fans</Link></li>
                                <li><Link to="/Artists" className="transition">Artists/Bands</Link></li>
                                <li><Link to="/Producers" className="transition">Producers</Link></li>
                                <li><Link to="/Musicians" className="transition">Musicians</Link></li>
                                <li><Link to="/RecordLabels" className="transition">Record Labels</Link></li>
                                <li><Link to="/Songwriters" className="transition">Songwriters</Link></li>
                                <li><Link to="/Venues" className="transition">Venues</Link></li>
                                <li><Link to="/Promoters" className="transition">Promoters</Link></li>
                                <li><Link to="/Managers" className="transition">Managers</Link></li>
                                <li><Link to="/RecordingStudios" className="transition">Recording Studios</Link></li>
                                <li><Link to="/RecommendedLinks" className="transition">Recommended Links</Link></li>
                            </ul>
                        </li>
                        <li><Link to="/Gigs">GO</Link></li>
                        <li className="hassub">
                            <a href="#">CHATTER <span className="caret" /></a>
                            <ul className="sub">
                                <li><Link to="/Discussions" className="transition">Discussions</Link></li>
                                <li><Link to="/ActivityFeed" className="transition">Activity Feed</Link></li>
                                <li><Link to="/Charts" className="transition">Trending</Link></li>
                                <li><Link to="/Announcements" className="transition">Announcements</Link></li>
                            </ul>
                        </li>
                        <li><Link to="/Discover" className="transition">DISCOVER</Link></li>
                        <li className="hassub">
                            <a href="#">READ <span className="caret" /></a>
                            <ul className="sub">
                                <li><Link to="/Blog" className="transition">Blog</Link></li>
                                <li><Link to="/Unsigned" className="transition">Unsigned Guide</Link></li>
                                <li><Link to="/PromoteYourMusic" className="transition">Promote Your Music</Link></li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            </div>
        </section>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.account.user };
}

function mapDispatchToProps(dispatch) {
    return {
        //account actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, accountActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);

SideMenu.propTypes = {
    user: PropTypes.object,
    actions: PropTypes.object.isRequired
};